
/**
 * Bridges `useLocationBookmarkState` between timeline/list cards and
 * `CombinedContentPlaceModal` so save / unsave stays in sync on the same Mongo location id.
 */

import React, { createContext, useContext } from 'react';
import type { UseLocationBookmarkStateReturn } from '@/hooks/useLocationBookmarkState';

export const LocationBookmarkStateContext = createContext<UseLocationBookmarkStateReturn | null>(null);

export function LocationBookmarkStateProvider({
  value,
  children,
}: {
  value: UseLocationBookmarkStateReturn;
  children: React.ReactNode;
}) {
  return (
    <LocationBookmarkStateContext.Provider value={value}>
      {children}
    </LocationBookmarkStateContext.Provider>
  );
}

export function useOptionalLocationBookmarkState(): UseLocationBookmarkStateReturn | null {
  return useContext(LocationBookmarkStateContext);
}
